import axios from 'axios';
import API from "../config/API";
import siteSetting from "../config/env";

export const eventService = {
    getEvent,
    editEvent,
    deleteEvent,
    affectedBookings
};

// Read-only: the bookings this block would land on, before it's saved.
// Same body as creating an event (send isBookingAllowed). Writes nothing.
function affectedBookings(params) {
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const { userId, ...body } = params;
    return axios.post(siteSetting.api.v2+"hairdresser/"+userId+'/events/affected-bookings', body, {headers:headers})
}


function getEvent(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    return axios.get(siteSetting.api.v2+"hairdresser/"+params.hairdresserId+'/events/'+params.eventId, {headers:headers})
}

function editEvent(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    const { hairdresserId, eventId, ...body } = params;
    return axios.put(siteSetting.api.v2+"hairdresser/"+hairdresserId+'/events/'+eventId,body,{headers:headers})
}

function deleteEvent(params) {
   let  headers= {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('accessToken'),
    }
    return axios.delete(siteSetting.api.v2+"hairdresser/"+params.hairdresserId+'/events/'+params.eventId, {headers:headers})
}

